"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _auth = require("@/utils/auth");
var _product = require("@/api/product");
var _productCdkey = require("@/api/productCdkey");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// import exportExcel from '@/utils/newToExcel.js';
var _default2 = exports.default = {
  name: 'editCdkey',
  props: {
    cdkeyInfo: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      cdkeyShow: false,
      carMyValidateForm: {
        cardNumber: '',
        secretNum: '',
        id: 0
      },
      btnloading: false
    };
  },
  watch: {
    cdkeyInfo: {
      handler: function handler(nVal, oVal) {
        this.carMyValidateForm = JSON.parse(JSON.stringify(nVal));
        // Object.assign(this.carMyValidateForm, nVal);
      },
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    //添加行
    handleAddCard: function handleAddCard() {
      this.carMyValidateForm.carMyList.push({
        cardNumber: '',
        secretNum: '',
        key: Date.now()
      });
    },
    handleClose: function handleClose() {
      this.cdkeyShow = false;
      this.$refs.carMyValidateForm.resetFields();
    },
    //保存
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.btnloading = true;
          (0, _productCdkey.cardSecretUpdateApi)(_this.carMyValidateForm).then(function (res) {
            _this.$message.success('编辑成功');
            _this.btnloading = false;
            _this.handleClose();
            _this.$emit('handlerEditSubSuccess');
          }).catch(function (res) {
            _this.btnloading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    })
  }
};